import React from "react";
import ReactDOM from 'react-dom';
import "./Result.css";

export default class Result extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rotation: 0,
            rotations: 0,
            settled: false
        };

        setTimeout(() => {
            this.setState({
                settled: true,
                rotation: this.calcRotation(resultScore)
            })
        }, 100)
    }

    calcRotation(score) {
        if (score > 55) {
            console.log("55");
            return (score - 55) / (maxScore - 55) * 60 + 30;
        } else if (score > 35) {
            console.log("35");
            return (score - 35) / (55 - 35) * 60 - 30;
        }
        console.log("rest");
        console.log(score);

        return score / 35 * 60 - 90;
    }

    render() {
        const rotation = (21 - 20) / 70 * 180;

        return (
            <div className={"Results-page " + (this.state.settled ? "settled" : "")}>
                <h2>jouw vitaliteit</h2>
                <div className={"graph"} onClick={this.showResults}>
                    <img className={"background"} src="/img/scale.svg"/>
                    <img className={"needle"} src="/img/needle.svg"
                         style={{"transform": `rotate(${this.state.rotation}deg)`}}/>
                </div>
                <div className={"result-text"}>
                    <h2>{resultTitle}</h2>
                    <p>{resultText}</p>
                </div>
            </div>
        )
    }

}

if (document.getElementById('result')) {
    ReactDOM.render(<Result />, document.getElementById('result'));
}
